var _radialGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_00000108296685483463910010000010376667745769527187_",
    cx: -1341.338,
    cy: 6883.762,
    gradientTransform: "matrix(800 0 0 -799.999 1073169 5507508.5)",
    gradientUnits: "userSpaceOnUse",
    r: 0.697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    stopColor: "#a033ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9348,
    stopColor: "#ff5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7061"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m256 0c-144.213 0-256 105.636-256 248.32 0 74.633 30.587 139.125 80.398 183.67 4.182 3.743 6.706 8.986 6.877 14.597l1.394 45.537c.445 14.526 15.449 23.977 28.741 18.109l50.812-22.431c4.307-1.9 9.134-2.253 13.673-1.004 23.35 6.421 48.201 9.841 74.104 9.841 144.212 0 256-105.636 256-248.32s-111.787-248.319-255.999-248.319z",
    fill: "url(#Path_00000108296685483463910010000010376667745769527187_)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000132047020611933167100000006482439701923528102_",
    d: "m102.273 320.94 75.2-119.306c11.962-18.98 37.577-23.706 55.525-10.245l59.81 44.858c5.488 4.117 13.038 4.094 18.503-.053l80.777-61.304c10.782-8.182 24.855 4.721 17.64 16.171l-75.2 119.307c-11.963 18.979-37.578 23.706-55.525 10.244l-59.812-44.859c-5.487-4.115-13.038-4.093-18.502.054l-80.777 61.304c-10.782 8.181-24.856-4.721-17.639-16.171z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.0d52134f957573616bdbea3d0b661ba9.svg";
export { ForwardRef as ReactComponent };